<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div class="matTitulo">
		<i class="fal fa-car" id="ico"></i>
		<h1 style="display: inline-block;">{{datos.descripcion}}</h1>
	</div>
	<mat-divider></mat-divider>
</div>
<div class="kt-portlet">
	<div class="kt-portlet__body">
		<div class="row">
			<div class="col col-sm-12 col-md-7 col-lg-7 contenido">
				<i style="margin-right: 3px;" class="fal fa-user col-md-1"></i><b>Cliente:</b> {{datos.cliente}}<br>
				<i style="margin-right: 3px;" class="fal fa-barcode-alt col-md-1"></i><b>Placa:</b> {{datos.placas}}<br>
				<i style="margin-right: 3px;" class="fal fa-credit-card-front col-md-1"></i><b>Economico:</b>
				{{datos.economico}}<br>
				<i style="margin-right: 3px;" class="fal fa-list-ol col-md-1"></i><b>Serie:</b>
				{{datos.numeroSerie}}<br>
				<i style="margin-right: 3px;" class="fal fa-trademark col-md-1"></i> <b>Marca:</b> {{datos.marca}}<br>
				<i style="margin-right: 3px;" class="fal fa-car col-md-1"></i> <b>Modelo:</b> {{datos.modelo}}<br>
				<i style="margin-right: 3px;" class="fal fa-calendar-alt col-md-1"></i><b>Año:</b> {{datos.anio}}<br>
				<i style="margin-right: 3px;" class="fal fa-tint col-md-1"></i><b>Color:</b> {{datos.color}}<br>
				<i style="margin-right: 3px;" class="fal fa-money-check-edit col-md-1"></i><b>Descripción:</b>
				{{datos.descripcion}}<br>
				<i style="margin-right: 3px;" class="fal fa-power-off col-md-1"></i><b>Ignición:</b> {{ignicion}}<br>
				<i style="margin-right: 3px;" class="fal fa-tachometer-alt-fast col-md-1"></i><b>Velocidad:</b>
				{{datos.velocidad}}
				Km/h<br>
				<i style="margin-right: 3px;" class="fal fa-clock col-md-1"></i><b>Fecha y Hora:</b> {{fecha}}
				{{hora}}<br>
				<!--<i style="margin-right: 3px;" class="fal fa-location-arrow col-md-1"></i><b>Última Posición:</b>
				[{{datos.lat | number: '1.1-4'}},
				{{datos.lng | number: '1.1-4'}}]<br>-->
				<ng-container *ngIf="datos.capacidadTanque != null">
					<i style="margin-right: 3px;" class="fal fa-gas-pump col-md-1"></i><b>Capacidad:</b>
					{{datos.capacidadTanque}} L
					<br>
				</ng-container>
				<ng-container *ngIf="datos.combustible != null">
					<i style="margin-right: 3px;" class="fal fa-arrow-down col-md-1"></i><b>Nivel de combustible:</b>
					{{datos.combustible}} L
					<br>
				</ng-container>
				<i style="margin-right: 3px;" class="fal fa-map col-md-1"></i><b>Latitud:</b>
					{{datos.lat}}
				<br>
				<i style="margin-right: 3px;" class="fal fa-map-marker col-md-1"></i><b>Longitud:</b>
					{{datos.lng}}
				<br>
				<i style="margin-right: 3px;" class="fal fa-draw-polygon col-md-1"></i><b>Geocerca:</b>
				{{geocercaAsignada}}<br>
				<i style="margin-right: 3px;" class="fal fa-map-pin col-md-1"></i><b>Dirección:</b> {{direccion}} <br>
			</div>
			<div class="col col-sm-12 col-md-5 col-lg-5 contenido">
				<img [src]="datos.imagen" style="width: 100%;" loading="lazy">
			</div>
		</div>
		<div class="row">
			<div class="col col-sm-12 col-md-12 col-lg-12" style="text-align: center;">
				<button *ngIf="this.datos.imeiCombustible == null" class="btnPopup ubicar mt-3" mat-raised-button (click)="ubicarVehiculo()"><i id="btnIco"
						class="fal fa-binoculars"></i>&nbsp;Ubicar</button>&nbsp;
				<button *ngIf="this.datos.imeiCombustible != null" class="btnPopup ubicar mt-3" mat-raised-button (click)="verGraficaCombustible()"><i id="btnIco"
						class="fal fa-gas-pump"></i>&nbsp;Combustible</button>&nbsp;
				<button class="btnPopup streetView  mt-3" mat-raised-button (click)="verStreet()"><i id="btnIco"
						class="fal fa-street-view"></i>&nbsp;Street View</button>&nbsp;
				<button class="btnPopup historico  mt-3" mat-raised-button (click)="verHistorico()"><i id="btnIco"
						class="fal fa-calendar-alt"></i>&nbsp;Histórico</button>&nbsp;
				<button class="btnPopup grafica  mt-3" mat-raised-button (click)="verGrafica()"><i id="btnIco"
						class="fal fa-chart-bar"></i>&nbsp;Gráfica Velocidad</button>&nbsp;

			</div>
		</div>
		<div class="row mt-3">
			<div class="col col-sm-12 col-md-12 col-lg-12" style="text-align: center;">
				<ng-container *ngIf=" datos.idEquipo !== 32">
					<button *ngIf="idCliente !== 39" class="btnPopup galeria mt-3" mat-raised-button
						(click)="verFoto(datos.imeiFk)"><i id="btnIco"
							class="fal fa-images"></i>&nbsp;Galería</button>&nbsp;
				</ng-container>


				<button *ngIf="datos.idEquipo == 32" class="btnPopup galeria mt-3" mat-raised-button
					(click)="verFotoNuevoDispositivo(datos.imeiFk)"><i id="btnIco"
						class="fal fa-images"></i>&nbsp;Galería</button>&nbsp;

				<button *ngIf="idCliente == 39" class="btnPopup videos  mt-3" mat-raised-button
					(click)="galeriaVideos(datos.imeiFk)"><i id="btnIco"
						class="fal fa-video"></i>&nbsp;Videos</button>&nbsp;
				<button *ngIf="idCliente !== 39" class="btnPopup pasoPunto mt-3" mat-raised-button
					(click)="pasoPorPunto()"><i id="btnIco" class="fal fa-thumbtack"></i>&nbsp;Paso por
					Punto</button>&nbsp;
				<button *ngIf="idCliente !== 39" class="btnPopup fueraGeocerca mt-3" mat-raised-button
					(click)="fueraGeocerca()"><i id="btnIco" class="fal fa-sign-out"></i>&nbsp;Fuera
					Geocerca</button>&nbsp;

				<button *ngIf="datos.fotoOperador != '' " class="btnPopup fotoOperador  mt-3" mat-raised-button
					(click)="mostrarOperador(datos)"><i id="btnIco"
						class="fal fa-camera-retro"></i>&nbsp;Operador</button>&nbsp;

			</div>
		</div>
		<!--<div class="row mt-3">
			<div class="col col-sm-12 col-md-12 col-lg-12" style="text-align: center;">
				<button class="btnPopup" (click)="ubicarVehiculo();"><i style="color:#01a7cd;"
						class="fal fa-binoculars"></i>&Wnbsp;
					Ubicar</button>
				<button class="btnPopup" (click)="verHistorico();"><i style="color:#01a7cd;"
						class="fal fa-calendar-alt"></i>&nbsp;
					Histórico</button>
				<button class="btnPopup" (click)="verStreet();"><i style="color:#01a7cd;"
						class="fal fa-street-view"></i>&nbsp;
					Street
					View</button>
			</div>
		</div>--
		<div class="row mt-3">
			<div class="col col-sm-12 col-md-12 col-lg-12" style="text-align: center;">
				<button *ngIf="idCliente !== 39"  class="btnPopup" (click)="pasoPorPunto();"><i style="color:#01a7cd;"
						class="fal fa-thumbtack"></i>&nbsp;
					Paso por punto</button>
				<button *ngIf="idCliente !== 39"  class="btnPopup" (click)="fueraGeocerca();"><i style="color:#01a7cd;"
						class="fal fa-sign-out"></i>&nbsp;
					Fuera Geocerca</button>
				<button *ngxPermissionsOnly="[permisoMensajesAutoModal]" class="btnPopup" (click)="verMensajes();"><i
						style="color:#01a7cd;" class="fal fa-comment-alt-lines"></i>
					Mensajes</button>--

			</div>
		</div>
		<div class="row mt-3">
			<div class="col col-sm-12 col-md-12 col-lg-12" style="text-align: center;">
				<button *ngIf="idCliente !== 39" class="btnPopup" (click)="verGrafica();"><i style="color:#01a7cd;"
						class="fal fa-chart-bar"></i>&nbsp;
					Gráfica</button>
				<button *ngxPermissionsOnly="[permisoGaleriaAutoModal]" class="btnPopup"
					(click)="verFoto(datos.imeiFk);"><i style="color:#01a7cd;" class="fal fa-images"></i>&nbsp;
					Galeria</button>

				<button *ngxPermissionsOnly="[permisoVisualizarVideos]" class="btnPopup"
					(click)="galeriaVideos(datos.imeiFk);"><i style="color:#01a7cd;" class="fal fa-video"></i>
					Videos</button>
			</div>
		</div>

	</div>-->
	</div>